import RenderedValue from './RenderedValue';
import React, { useContext, useMemo } from 'react';
import { DragBoxHoveredCells } from './DragBoxHoverProvider';
import OverrideableRenderedValue from './OverrideableRenderedValue';
import useSelectedFigureItems from './useSelectedFigureItems';

import SelectedCover from './SelectedCover';

const COVER = <SelectedCover/>


function isCellInList(list,x,y){

	return list.find(selItem => {
		return selItem[0] === y && selItem[1] === x
	});
}

export default function GridValueContainer(props){

	let { cell } = props;

	let coverWouldGoAfter = useMemo(() => ['crop','image'].includes(props.value.valueType),[props]);

	let selectedFigureItems = useSelectedFigureItems();

	

	let { x, y } = cell;

	
	let dragBoxHoveredCells = useContext(DragBoxHoveredCells);

	let shouldEmphasize = useMemo(() => {
		let selectedCells = selectedFigureItems?.cells || [];

		let dragHovered = isCellInList(dragBoxHoveredCells,x,y);
		let isSelectedCell = isCellInList(selectedCells,x,y);  


		return dragHovered || isSelectedCell;
	},[dragBoxHoveredCells,x,y,selectedFigureItems])
	

	let toRender = useMemo(() => {
		if( shouldEmphasize ){
			return <OverrideableRenderedValue {...props}/>
		}else{
			return <RenderedValue {...props}/>
		}
	},[shouldEmphasize,props]);



  let toCover = shouldEmphasize && (
    (coverWouldGoAfter ? "post" : "pre")+"Cover"
  )

  let covers = { 
    [toCover]:<SelectedCover {...{cell:y+'-'+x} }/> 
  }
  


	return (
		<>
			{covers.preCover}
			{toRender}
			{covers.postCover}
		</>
	)




}
